export default {"src":"/kaimono/_next/static/media/coupon.0ace5644.svg","height":36,"width":36};